import { render, staticRenderFns } from "./ActiveFilterChips.vue?vue&type=template&id=12e90687&scoped=true"
import script from "./ActiveFilterChips.vue?vue&type=script&lang=js"
export * from "./ActiveFilterChips.vue?vue&type=script&lang=js"
import style0 from "./ActiveFilterChips.vue?vue&type=style&index=0&id=12e90687&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e90687",
  null
  
)

export default component.exports